import { getMainColor, isValidationColor } from '@gef-ui/material-theme-utils/colors';
export default function Radio(theme) {
    return {
        MuiRadio: {
            styleOverrides: {
                root: (input)=>({
                        padding: theme.spacing(1),
                        color: isValidationColor(input) ? getMainColor(input) : undefined,
                        svg: {
                            fontSize: 24,
                            '&[font-size=small]': {
                                fontSize: 20
                            }
                        }
                    })
            }
        }
    };
}
